import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  GetMetricsTokenAndURLParams,
  GetMetricsTokenAndURLResponse,
  GetTokenAndURLParams,
  GetTokenAndURLResponse,
} from '..';

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  private _chartioUrl = environment.chartioUrl;
  private _metricsUrl = environment.metricsUrl;

  constructor(private http: HttpClient) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  getMetricsTokenAndURL(
    getTokenAndURLParams: GetMetricsTokenAndURLParams
  ): Observable<GetMetricsTokenAndURLResponse> {
    let params = new HttpParams();

    Object.keys(getTokenAndURLParams).forEach((param) => {
      params = params.append(param, getTokenAndURLParams[param]);
    });

    return this.http
      .get(this._metricsUrl, { params })
      .pipe(catchError(this.formatErrors))
      .pipe(map((data: GetMetricsTokenAndURLResponse) => data));
  }

  getChartioTokenAndURL(
    getTokenAndURLParams: GetTokenAndURLParams
  ): Observable<GetTokenAndURLResponse> {
    let params = new HttpParams();

    Object.keys(getTokenAndURLParams).forEach((param) => {
      params = params.append(param, getTokenAndURLParams[param]);
    });

    return this.http
      .get(this._chartioUrl, { params })
      .pipe(catchError(this.formatErrors))
      .pipe(map((data: GetTokenAndURLResponse) => data));
  }
}
